// extracted by mini-css-extract-plugin
export var appBody = "sitefinity-layout-module--appBody--2ebda";
export var content = "sitefinity-layout-module--content--a2fc3";
export var contentCol = "sitefinity-layout-module--contentCol--721a7";
export var footerWrap = "sitefinity-layout-module--footerWrap--2c231";
export var fullScreen = "sitefinity-layout-module--fullScreen--470cd";
export var hideToc = "sitefinity-layout-module--hideToc--83fea";
export var mainContainer = "sitefinity-layout-module--mainContainer--f06c3";
export var navCol = "sitefinity-layout-module--navCol--96f22";
export var tocContainer = "sitefinity-layout-module--tocContainer--2fe65";